import Account from './Account'

import slice from './account.slice'

export const {
	name,
	actions: { updateFilter },
	reducer,
} = slice

export * from './account.asyncActions'
export * from './account.selector'

export default Account
